// extracted by mini-css-extract-plugin
export default {"root":"ui__shared__right-content-menu__block-list__root","blockItem":"ui__shared__right-content-menu__block-list__blockItem"};